module.exports = __webpack_public_path__ + "img/xm01-33363c.jpg";